<template>
  <transition name="slide" appear>
    <div
      v-if="isFlashVisible"
      :class="['flash-message', flashType]"
    >
      {{ flashMessage }}
    </div>
  </transition>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();
    const flashMessage = computed(() => store.state.flashMessage);
    const flashType = computed(() => store.state.flashType);
    const isFlashVisible = computed(() => store.state.isFlashVisible);

    return { flashMessage, flashType, isFlashVisible };
  }
};
</script>

<style scoped>
.flash-message {
  position: fixed;
  top: 20px;
  right: 20px;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  /* 初期位置はアニメーションで制御するため、transform は不要 */
}

.success {
  background-color: green;
}

.danger {
  background-color: red;
}

.warning {
  background-color: yellow;
}

/* スライドアニメーション */
.slide-enter-active, .slide-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-enter-from {
  transform: translateX(100%); /* 画面外から入る */
  opacity: 0; /* 透明 */
}

.slide-enter-to {
  transform: translateX(0); /* 完全に表示位置に固定 */
  opacity: 1; /* 表示 */
}

.slide-leave-from {
  transform: translateX(0); /* 表示位置から開始 */
  opacity: 1; /* 表示 */
}

.slide-leave-to {
  transform: translateX(100%); /* 画面外へ移動 */
  opacity: 0; /* 消える */
}
</style>
